import './missionGroup.less';

angular.module("tromanWeb").controller('MissionGroupController', ['stateService', 'tromanServer', 'dialogService', 'missionGroupShared', function (stateService, tromanServer, dialogService, missionGroupShared) {
    this.missionGroup = missionGroupShared.missionGroup;


    this.hardRemove = function hardRemove() {
        if (this.missionGroup == null || this.missionGroup.Id == null) return;

        dialogService.confirm(["Radera " + this.missionGroup.Name + " permanent.", "Detta kan inte ångras", "Är du säker?"])
            .then(() => {
                tromanServer.MissionGroups.hardRemove(this.missionGroup.Id)
                    .then(() => { stateService.forceGo('missiongroups'); })
                    .catch(dialogService.error);
            });
    };

}]);
